const groupItems = <T>(
  arr: T[],
  keyExtractor: keyof T | ((item: T) => string),
): Record<string, T[]> => {
  return arr.reduce((prev, item) => {
    const key: string =
      typeof keyExtractor === "function"
        ? keyExtractor(item)
        : String(item[keyExtractor]);

    if (!prev[key]) {
      prev[key] = [];
    }
    prev[key]!.push(item);

    return prev;
  }, {} as Record<string, T[]>);
};

export const ArrayUtils = { groupItems };
